<template>
    <div class="Classroom no-trans" v-loading="loading">
        <div class="banners">
            <img src="../../../assets/img/index/law/banner1.png" alt="">
        </div>
        <div class="checks">
            <div class="check_box">
                <div class="check_item" v-for="(item, index) in check_list" :key="index" @click="handle_type(item)">
                    <div class="check_img">
                        <img v-if="!mobile_view || item.image" :src="item.image" alt="">
                        <i v-else class="el-icon-folder-opened" aria-hidden="true"></i>
                    </div>
                    <div class="check_info">
                        <div class="check_title">{{ item.title }}</div>
                        <div class="check_list">
                            <div class="check_list_item" v-for="(items, indexs) in item.child" :key="indexs">{{
                                items.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Hotspot_recommendation">
            <div class="Hotspot_recommendation_box">

                <div class="titles_box">
                    <div class="title_text1">热点推荐</div>
                    <div class="title_text2">
                        HOTSPOT RECOMMENDATION
                        <img src="@/assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="gpt_rec_flex">
                    <div class="gpt_rec_left" @click="handle_nwe(tj_ac)">
                        <div class="left_img">
                            <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                             <img :src="tj_ac.thumb" alt="">
                        </div>
                        <!-- {{ tj_ac }} -->
                        <div class="left_titles">
                            {{ tj_ac.title }}
                        </div>
                        <div class="left_times">{{ mobile_view ? tj_ac.created_at : '贷款纠纷 · ' + (tj_ac.created_at || '') }}</div>
                        <div class="left_consts">
                            {{ tj_ac.description }}
                            <span class="btns_a">查看全文</span>
                        </div>
                    </div>
                    <div class="gpt_rec_right">
                        <div class="right_lists">
                            <div class="items" v-for="(item, index) in nwe_tj_list" :key="index" v-if="!mobile_view || item.id !== tj_ac.id" @click="handle_nwe(item)">
                                <div class="item_title">
                                    {{ item.title }}
                                    <img src="@/assets/img/index/legal/title_bg.png" alt="">
                                </div>
                                <div class="item_const">
                                    {{ item.description }}<span
                                        class="item_btns">查看全文</span>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Recommend_a_lawyer">
            <div class="Recommend_a_lawyer_box">
                <div class="titles_box">
                    <div class="title_text1">律师推荐</div>
                    <div class="title_text2">
                        RECOMMEND A LAWYER
                        <img src="@/assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="list_item">
                    <div class="item" v-for="(item, index) in ls_list" :key="index" @click="handle_ls(item)">
                        <div class="item_left">
                            <div class="item_left_tops">
                                <div class="item_title">{{ item.name }}</div>
                                <div class="item_firm">{{ item.work_company }}</div>
                                <div class="item_tage">{{ item.serve }}</div>
                            </div>
                            <div class="item_left_boms">
                                <div class="btns1">立即咨询</div>
                            </div>
                        </div>
                        <div class="item_right">
                            <!-- <img src="../../../assets/img/index/home/lsimg.png" alt=""> -->
                            <img :src="item.business_img" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="News_hotspot">
            <div class="News_hotspot_box">
                <div class="titles_box">
                    <div class="title_text1">新闻热点</div>
                    <div class="title_text2">
                        NEWS HOTSPOT
                        <img src="@/assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="check_type" ref="news_tabs" role="tablist" aria-label="新闻热点分类">
                    <div class="tab_list" v-for="(item, index) in check_list2" :key="index"
                        role="tab" :tabindex="cehck_ac.id == item.id ? 0 : -1" :aria-selected="String(cehck_ac.id == item.id)"
                        @keydown.enter.prevent="handle_cehck(item, index)" @keydown.space.prevent="handle_cehck(item, index)"
                        @keydown.left.prevent="handle_tab_key(index, -1)" @keydown.right.prevent="handle_tab_key(index, 1)"
                        :class="{ tab_list_ac: cehck_ac.id == item.id }" @click="handle_cehck(item, index)">
                        <div class="tab_title">
                            {{ item.title }}
                        </div>
                        <div class="borders"></div>
                    </div>
                </div>
                <div class="check_item">
                    <div class="item_ac_left">
                        <div class="left_title">{{ cehck_ac.title }}</div>
                        <div class="left_texts">{{cehck_ac.description}}</div>
                        <!-- <div class="left_nums"><span>13</span>细分领域</div> -->
                        <div class="left_nums2"><span>{{ nwe_length }}</span>+精选文章</div>
                        <div class="left_btns" @click="handle_cehck_ac_path">进入专区</div>
                    </div>
                    <div class="item_ac_right">
                        <div class="items" :class="{ 'news-without-image': !item.thumb }" v-for="(item,index) in nwe_list2" :key="index" @click="handle_nwe(item)">
                            <div class="item_img" v-if="!mobile_view || item.thumb">
                                <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                                 <img :src="item.thumb" alt="">
                            </div>
                            <div class="item_info">
                                <div class="item_title">
                                    {{ item.title }}
                                </div>
                                <div class="item_const">
                                    {{ item.description }}<span>查看全文</span>
                                </div>
                                <div class="item_icons">
                                <div class="icons">
                                    <img src="../../../assets/img/index/comments_case/time.png" alt="">
                                    {{ mobile_view ? (item.created_at || '').slice(0, 10) : item.created_at }}
                                </div>
                                <div class="icons">
                                    <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                    {{ item.view_num }}

                                </div>
                            </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Featured_Cases">
            <div class="Featured_Cases_box">
                <div class="titles_box">
                    <div class="title_text1">精选案例</div>
                    <div class="title_text2">
                        FDATURED CASES
                        <img src="@/assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="list_box">
                    <div class="items" v-for="(item,index) in caseList" :key="index" @click="handle_case(item)"
                        :role="mobile_view ? 'link' : null" :tabindex="mobile_view ? 0 : null"
                        @keydown.enter.prevent="handle_case(item)">
                        <div class="item_title">
                            {{ item.title }}
                        </div>
                        <div class="item_const">
                            {{ item.desc }}
                        </div>
                        <div class="item_icons">
                            <div class="icons">
                                <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                {{ item.views }}<span v-if="mobile_view">浏览</span>
                            </div>
                            <div class="icons">
                                <img src="../../../assets/img/index/comments_case/pl_num.png" alt="">
                                {{ item.comment_num }}<span v-if="mobile_view">评论</span>
                            </div>
                        </div>
                        <i v-if="mobile_view" class="case_arrow el-icon-arrow-right" aria-hidden="true"></i>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import { useListeners } from 'vue';
import {
    mapState
} from 'vuex'



export default {
    components: {

         
    },
    name: "homes",
    data() {
        return {
            loading: false,
            check_list: [],
            cehck_ac: {},
            check_list2: [],
            nwe_list2:[],
            nwe_length:0,
            nwe_tj_list:[],
            tj_ac:{},
            ls_list:[],
            caseList:[],
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_ls_list()
        this.get_check_list()
        this.get_check_list2()
        this.get_nwe_tj_list()
        this.get_caseList()
    },
    methods: {
        handle_cehck_ac_path(){

          this.$router.push({
            path:'/hot_spot_type',
            query:{
                id:this.cehck_ac.id,
                parent_id:4,
            },
          })
        },
        handle_case(item){
            this.$router.push({
                path:'/comments_detial',
                query:{
                    id:item.id
                },
            })
        },
        handle_type(item){
            this.$router.push({
                path:'/hot_spot_type',
                query:{
                    id:item.id
                },
            })
        },
        handle_ls(item){
            this.$router.push({
                path:'/lawyer_detial',
                query:{
                    id:item.id
                },
            })
        },
       
        handle_cehck(item, index) {
            this.cehck_ac = item
            this.get_check_list2_new()
            if (this.mobile_view) this.$nextTick(() => {
                const tab = this.$refs.news_tabs && this.$refs.news_tabs.children[index]
                if (tab) tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' })
            })
        },
        handle_tab_key(index, direction) {
            const next = (index + direction + this.check_list2.length) % this.check_list2.length
            this.handle_cehck(this.check_list2[next], next)
            this.$nextTick(() => this.$refs.news_tabs.children[next].focus())
        },
        handle_nwe(item){
            this.$router.push({
                path:'/hot_spot_type_detial',
                query:{
                    id:item.id
                }
            })
        },
        get_ls_list(){
            this.loading=true
            this.$api("lawyers", {
                recommend:1,
                limit:3,
			}, "get").then((res) => {
                this.loading = false
                console.log('律师推荐',res)
                if (res.code == 1) {
                    
                    this.ls_list=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_nwe_tj_list(){
            this.loading=true
            this.$api("getArticleList", {
                category_id:29,
                limit:4,
			}, "get").then((res) => {
                this.loading = false
                console.log('热点推荐',res)
                if (res.code == 1) {
                    this.nwe_tj_list=res.data.list
                    this.tj_ac=res.data.list[0]
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_check_list(){
            this.loading=true
            this.$api("getArticleCategoryList", {
                // parent_id:19,
			}, "get").then((res) => {
                this.loading = false
                console.log('首页法界热点分类1',res)
                if (res.code == 1) {
                    res.data.forEach((e)=>{
                        if(e.id==2){
                            e.child.forEach((v)=>{
                                if(v.id==19){
                                    this.check_list=v.child
                                }
                            })
                        }
                    })
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_check_list2(){
            this.loading=true
            this.$api("getArticleCategoryList", {
                parent_id:4,
			}, "get").then((res) => {
                this.loading = false
                console.log('首页法界热点分类1',res)
                if (res.code == 1) {
                    this.check_list2=res.data
                    this.cehck_ac=res.data[0]
                    this.get_check_list2_new()
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_check_list2_new(){
            this.loading=true
            this.$api("getArticleList", {
                category_id:this.cehck_ac.id,
                limit:3,
			}, "get").then((res) => {
                this.loading = false
                console.log('新闻热点',res)
                if (res.code == 1) {
                    this.nwe_list2=res.data.list
                    this.nwe_length=res.data.count
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_caseList(){
            this.loading=true
            this.$api("caseList", {
                limit:4,
            }, "get").then((res) => {
                this.loading = false
                console.log('案例点评',res)
                if (res.code == 1) {
                    this.caseList=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.Classroom {
    width: 100%;
    // height: 680px;
    // background-color: ;
    // padding:21px ;
    // padding-bottom: 100px;

    .banners {
        width: 100%;
        height: 480px;
        position: relative;
        z-index: 1;

        img {
            width: 100%;
            height: 480px;
        }
    }

    .checks {
        width: 100%;
        background: #FFFFFF;

        .check_box {
            width: 1440px;
            height: 258px;
            background: #FFFFFF;
            box-shadow: 2px 2px 10px 1px rgba(1, 9, 46, 0.1);
            border-radius: 8px 8px 8px 8px;
            margin: auto;
            margin-top: -149px;
            position: relative;
            z-index: 2;
            padding: 40px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .check_item {
                width: 25%;
                // padding-right: 30px;
                // height: 50%;
                margin-bottom: 30px;
                display: flex;
                cursor: pointer;

                .check_img {
                    img {
                        width: 32px;
                    }
                }

                .check_info {
                    padding-left: 16px;

                    .check_title {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;

                    }

                    .check_list {
                        width: 240px;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        padding-top: 6px;

                        .check_list_item {
                            margin-right: 24px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #999999;
                            margin-bottom: 6px;
                        }
                    }

                }

            }
        }
    }

    .titles_box {
        display: flex;
        align-items: end;

        .title_text1 {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 36px;
            color: #333333;
        }

        .title_text2 {
            padding-left: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #B3CDFE;

            img {
                width: 24px;
                height: 24px;
                margin-left: 15px;
                vertical-align: middle;
            }
        }

    }

    .Hotspot_recommendation {
        padding-top: 56px;
        padding-bottom: 50px;

        .Hotspot_recommendation_box {
            width: 1440px;
            margin: auto;

            .gpt_rec_flex {
                display: flex;
                padding-top: 40px;

                .gpt_rec_left {
                    width: 440px;

                    .left_img {
                        width: 440px;
                        height: 293px;

                        img {
                            width: 440px;
                            height: 293px;
                        }
                    }

                    .left_titles {
                        padding-top: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                    }

                    .left_times {
                        padding-top: 10px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 12px;
                        color: #999999;

                    }

                    .left_consts {
                        width: 100%;
                        // display: flex;
                        // align-items: center;
                        word-break: break-all;
                        word-wrap: break-word;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        padding-top: 16px;
                        color: #666666;

                        .btns_a {
                            color: #377CFD;
                            cursor: pointer;
                        }
                    }
                }

                .gpt_rec_right {
                    padding-left: 48px;

                    .right_lists {
                        .items {
                            cursor: pointer;
                            margin-bottom: 32px;

                            .item_title {
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 18px;
                                color: #333333;

                                img {
                                    margin-left: 12px;
                                    width: 19px;
                                }
                            }

                            .item_const {
                                padding-top: 16px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;

                                .item_btns {
                                    color: #377CFD;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .Recommend_a_lawyer {
        background-color: #F5F5F5;
        padding-top: 64px;
        padding-bottom: 82px;

        .Recommend_a_lawyer_box {
            width: 1440px;
            margin: auto;

            .list_item {
                display: flex;
                align-items: center;
                // justify-content: space-between;
                padding-top: 48px;

                .item {
                    width: 458px;
                    min-height: 258px;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    display: flex;
                    // align-items: center;
                    padding: 32px 15px 0 24px;
                    margin-right: 33px;
                    justify-content: space-between;
                    &:last-child{
                        margin: 0;
                    }
                    .item_left {
                        width: 180px;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: space-between;

                        .item_left_tops {
                            width: 100%;

                            .item_title {
                                font-weight: bold;
                                font-size: 24px;
                                color: #333333;
                                word-break: break-all;
                            }

                            .item_firm {
                                font-weight: bold;
                                font-size: 14px;
                                color: #333333;
                                padding-top: 10px;
                            }

                            .item_tage {
                                padding-top: 20px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                word-break: break-all;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp:2;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .item_left_boms {
                            // display: flex;
                            // align-items: center;
                            padding-bottom: 30px;

                            .btns1 {
                                width: 180px;
                                height: 40px;
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px;
                                text-align: center;
                                line-height: 40px;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #FFFFFF;

                            }
                        }
                    }

                    .item_right {
                        width: 224px;
                        height: 100%;
                        overflow: hidden;
                        flex-shrink: 0;

                        img {
                            width: 224px;
                        }
                    }
                }
            }
        }
    }

    .News_hotspot {
        padding-top: 62px;
        padding-bottom: 80px;

        .News_hotspot_box {
            width: 1440px;
            margin: auto;
            .check_type {
                display: flex;
                align-items: center;
                padding-top: 50px;
                // padding-bottom: 20px;
                border-bottom: 2px solid #EDEDED;

                .tab_list {
                    margin-right: 80px;
                    cursor: pointer;

                    // height: 100%;
                    .tab_title {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #999999;
                    }

                    .borders {
                        width: 72px;
                        height: 3px;
                        background: #fff;
                        margin-top: 18px;
                        border-radius: 0px 0px 0px 0px;
                    }

                    &:hover {
                        .tab_title {
                            color: #377CFD;
                        }

                        .borders {
                            background: #377CFD;
                        }
                    }
                }

                .tab_list_ac {
                    .tab_title {
                        color: #377CFD;
                    }

                    .borders {
                        background: #377CFD;
                    }
                }
            }
            .check_item{
                padding-top: 40px;
                display: flex;
                align-items: center;
                .item_ac_left{
                    width: 420px;
                    height: 400px;
                    background: #F7F7F7;
                    border-radius: 8px 8px 8px 8px;
                    padding: 46px 32px ;
                    .left_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333;

                    }
                    .left_texts{
                     padding-top: 15px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .left_nums{
                        padding-top: 40px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        span{
                            color: #333333;
                            font-size: 36px;
                            font-weight: bold;
                        }
                    }
                    .left_nums2{
                      
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        span{
                            color: #333333;
                            font-size: 36px;
                            font-weight: bold;
                        }

                    }
                    .left_btns{
                        width: 180px;
                        height: 40px;
                        background: #377CFD;
                        border-radius: 4px 4px 4px 4px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 40px;
                        cursor: pointer;
                        margin-top: 56px;
                    }
                }
                .item_ac_right{
                    display: flex;
                    align-items: center;
                    // justify-content: space-between;
                    flex: 1;
                    padding-left: 24px;
                    .items{
                        width: 316px;
                        height: 400px;
                        background: #FFFFFF;
                        border-radius: 8px 8px 8px 8px;
                        border: 1px solid #D7D7D7;
                        margin-right: 24px;
                        &:last-child{
                            margin: 0;
                        }
                        .item_img{
                            width: 100%;
                            height: 216px;
                            img{
                                width: 100%;
                                height: 216px;
                            }
                        }
                        .item_info{
                            padding:16px 16px 24px 16px;
                            .item_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp:1;
                                -webkit-box-orient: vertical;
                            }
                            .item_const{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #666666;
                                padding-top: 16px;
                                span{
                                    cursor: pointer;
                                    color: #377CFD;
                                }
                            }
                        }
                        .item_icons{
                            display: flex;
                            align-items: center;
                            padding-top: 20px;
                            .icons{
                                margin-right: 16px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                
                                img{
                                    width: 19px;
                                    // height: 19px;
                                }
                            }
                        }
                    }

                }

            }
        }


    }
    .Featured_Cases{
        background-color: #F5F5F5;
        padding-bottom: 100px;
        .Featured_Cases_box{
            width: 1440px;
            margin: auto;
            padding-top: 80PX;
            .list_box{
                padding-top: 37px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                .items{
                    width: 708px;
                    height: 236px;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    margin-bottom: 20px;
                    padding: 32px 40px;
                    cursor: pointer;
                    .item_title{
                        width: 450px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 20px;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp:1;
                        -webkit-box-orient: vertical;
                    }
                    .item_const{
                       
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        margin-top: 20px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp:2;
                        -webkit-box-orient: vertical;
                    }
                    .item_icons{
                        margin-top: 26px;
                        border-top: 1px solid #EDEDED;
                        padding-top: 26px;
                        display: flex;
                        align-items: center;
                        .icons{
                            display: flex;
                            align-items: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            margin-left:24px ;
                            img{
                                // width: 25px;
                                height: 15px;
                                margin-right: 8px;

                            }

                        }
                    }
                }
            }
        }
    }



}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .Classroom.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .Classroom.no-trans .banners {
        min-height: 0;
        height: auto;
    }
    .Classroom.no-trans .banners img {
        min-height: 0;
        height: auto;
    }
    .Classroom.no-trans .checks .check_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        margin: auto;
        margin-top: -16px;
        padding: 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .Classroom.no-trans .checks .check_box .check_item {
        margin-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .Classroom.no-trans .checks .check_box .check_item .check_img img {
        width: 32px;
    }
    .Classroom.no-trans .checks .check_box .check_item .check_info {
        padding-left: 16px;
    }
    .Classroom.no-trans .checks .check_box .check_item .check_info .check_title {
        font-size: 18px;
    }
    .Classroom.no-trans .checks .check_box .check_item .check_info .check_list {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
        padding-top: 6px;
    }
    .Classroom.no-trans .checks .check_box .check_item .check_info .check_list .check_list_item {
        margin-right: 16px;
        font-size: 14px;
        margin-bottom: 6px;
    }
    .Classroom.no-trans .titles_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .Classroom.no-trans .titles_box .title_text1 {
        font-size: 24px;
    }
    .Classroom.no-trans .titles_box .title_text2 {
        padding-left: 16px;
        font-size: 24px;
    }
    .Classroom.no-trans .titles_box .title_text2 img {
        width: 24px;
        height: 24px;
        margin-left: 15px;
    }
    .Classroom.no-trans .Hotspot_recommendation {
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_left {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_left .left_img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_left .left_img img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_left .left_titles {
        padding-top: 16px;
        font-size: 18px;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_left .left_times {
        padding-top: 10px;
        font-size: 14px;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_left .left_consts {
        font-size: 14px;
        padding-top: 16px;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_right {
        padding-left: 16px;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_right .right_lists .items {
        margin-bottom: 16px;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_right .right_lists .items .item_title {
        font-size: 18px;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_right .right_lists .items .item_title img {
        margin-left: 12px;
        width: 19px;
    }
    .Classroom.no-trans .Hotspot_recommendation .Hotspot_recommendation_box .gpt_rec_flex .gpt_rec_right .right_lists .items .item_const {
        padding-top: 16px;
        font-size: 14px;
    }
    .Classroom.no-trans .Recommend_a_lawyer {
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item .item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 8px 8px 8px 8px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 16px 15px 0 16px;
        margin-right: 16px;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item .item:last-child {
        margin: 0;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item .item .item_left {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item .item .item_left .item_left_tops .item_title {
        font-size: 24px;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item .item .item_left .item_left_tops .item_firm {
        font-size: 14px;
        padding-top: 10px;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item .item .item_left .item_left_tops .item_tage {
        padding-top: 16px;
        font-size: 14px;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item .item .item_left .item_left_boms {
        padding-bottom: 16px;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item .item .item_left .item_left_boms .btns1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item .item .item_right {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .Classroom.no-trans .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item .item .item_right img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
    }
    .Classroom.no-trans .News_hotspot {
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_type {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_type .tab_list {
        margin-right: 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_type .tab_list .tab_title {
        font-size: 18px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_type .tab_list .borders {
        width: 72px;
        height: 3px;
        margin-top: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item {
        padding-top: 12px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-bottom: 12px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_left {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        padding: 16px 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_left .left_title {
        font-size: 24px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_left .left_texts {
        padding-top: 15px;
        font-size: 14px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_left .left_nums {
        padding-top: 16px;
        font-size: 14px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_left .left_nums span {
        font-size: 24px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_left .left_nums2 {
        font-size: 14px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_left .left_nums2 span {
        font-size: 24px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_left .left_btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 40px;
        margin-top: 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-left: 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        margin-right: 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items:last-child {
        margin: 0;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items .item_img {
        min-height: 0;
        height: auto;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items .item_img img {
        min-height: 0;
        height: auto;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items .item_info {
        padding: 16px 16px 16px 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items .item_info .item_title {
        font-size: 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items .item_info .item_const {
        font-size: 14px;
        padding-top: 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items .item_icons {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items .item_icons .icons {
        margin-right: 16px;
        font-size: 14px;
    }
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items .item_icons .icons img {
        width: 19px;
    }
    .Classroom.no-trans .Featured_Cases {
        padding-bottom: 16px;
    }
    .Classroom.no-trans .Featured_Cases .Featured_Cases_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        padding-top: 80PX;
    }
    .Classroom.no-trans .Featured_Cases .Featured_Cases_box .list_box {
        padding-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .Classroom.no-trans .Featured_Cases .Featured_Cases_box .list_box .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        margin-bottom: 16px;
        padding: 16px 16px;
    }
    .Classroom.no-trans .Featured_Cases .Featured_Cases_box .list_box .items .item_title {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        font-size: 20px;
    }
    .Classroom.no-trans .Featured_Cases .Featured_Cases_box .list_box .items .item_const {
        font-size: 14px;
        margin-top: 16px;
    }
    .Classroom.no-trans .Featured_Cases .Featured_Cases_box .list_box .items .item_icons {
        margin-top: 16px;
        padding-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .Classroom.no-trans .Featured_Cases .Featured_Cases_box .list_box .items .item_icons .icons {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        margin-left: 16px;
    }
    .Classroom.no-trans .Featured_Cases .Featured_Cases_box .list_box .items .item_icons .icons img {
        height: 15px;
        margin-right: 8px;
    }
}
@media (max-width: 1024px) {
    .Classroom.no-trans {
        background: #fff;
        .banners img { display: block; width: 100%; height: auto; }
        .titles_box {
            display: flex; flex-direction: column; align-items: flex-start; gap: 2px;
            .title_text1 { font-size: 20px; line-height: 28px; color: #27364b; }
            .title_text2 { padding: 0; font-size: 13px; line-height: 20px; color: #7e8ba0; overflow-wrap: anywhere; }
            .title_text2 img { display: none; }
        }
        .checks .check_box {
            display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px;
            margin: 0; padding: 16px; border-radius: 0; box-shadow: none; background: #fff;
            .check_item {
                display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 8px; width: 100%; min-height: 76px;
                margin: 0; padding: 12px 10px; background: #f5f8fd; border: 1px solid #e8eef6; border-radius: 6px;
                .check_img { flex: 0 0 24px; width: 24px; height: 24px; }
                .check_img img { width: 24px; height: 24px; object-fit: contain; }
                .check_img i { font-size: 24px; color: #377cfd; }
                .check_info { flex: 1; min-width: 0; padding: 0; }
                .check_info .check_title { font-size: 15px; line-height: 24px; font-weight: 600; overflow-wrap: anywhere; }
                .check_info .check_list { display: block; padding-top: 4px; max-height: 22px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
                .check_info .check_list .check_list_item { display: inline; margin: 0 6px 0 0; font-size: 13px; line-height: 22px; color: #7b8492; }
                .check_info .check_list:empty { display: none; }
            }
        }
        .Hotspot_recommendation, .Recommend_a_lawyer, .News_hotspot, .Featured_Cases { padding: 24px 16px; }
        .Hotspot_recommendation .Hotspot_recommendation_box,
        .Recommend_a_lawyer .Recommend_a_lawyer_box,
        .News_hotspot .News_hotspot_box,
        .Featured_Cases .Featured_Cases_box { width: 100%; padding: 0; }
        .Hotspot_recommendation {
            border-top: 8px solid #f4f6f9;
            .Hotspot_recommendation_box .gpt_rec_flex {
                display: flex; flex-direction: column; align-items: stretch; gap: 0; padding-top: 16px;
                .gpt_rec_left {
                    width: 100%; padding-bottom: 16px;
                    .left_img { width: 100%; height: auto; aspect-ratio: ~"16 / 9"; max-height: 280px; overflow: hidden; border-radius: 4px; background: #f1f4f8; }
                    .left_img img { display: block; width: 100%; height: 100%; object-fit: cover; }
                    .left_titles { margin: 0; padding-top: 12px; font-size: 18px; line-height: 28px; overflow-wrap: anywhere; }
                    .left_times { margin: 0; padding-top: 6px; font-size: 13px; line-height: 22px; color: #7b8492; }
                    .left_consts { padding-top: 8px; font-size: 14px; line-height: 24px; color: #687587; }
                    .left_consts .btns_a { display: none; }
                }
                .gpt_rec_right { width: 100%; }
                .gpt_rec_right .right_lists .items {
                    padding: 14px 0; margin: 0; border-top: 1px solid #edf0f5;
                    .item_title { display: block; font-size: 16px; line-height: 25px; overflow-wrap: anywhere; }
                    .item_title img { display: none; }
                    .item_const { padding-top: 6px; font-size: 13px; line-height: 22px; color: #7b8492; }
                    .item_const .item_btns { display: none; }
                }
            }
        }
        .Recommend_a_lawyer {
            background: #f4f6f9;
            .Recommend_a_lawyer_box .list_item {
                display: grid; grid-template-columns: 1fr; gap: 12px; padding-top: 16px;
                .item {
                    display: grid; grid-template-columns: 72px minmax(0, 1fr); align-items: start; gap: 12px;
                    width: 100%; min-height: 0; padding: 14px; margin: 0; border: 1px solid #e6ebf2; border-radius: 6px;
                    .item_right { grid-column: 1; grid-row: 1; width: 72px; height: 88px; border-radius: 4px; background: #f1f4f8; }
                    .item_right img { display: block; width: 100%; height: 100%; object-fit: cover; object-position: top; }
                    .item_left { grid-column: 2; grid-row: 1; display: block; width: 100%; padding: 0; min-width: 0; }
                    .item_left .item_left_tops .item_title { font-size: 17px; line-height: 26px; }
                    .item_left .item_left_tops .item_firm { padding-top: 4px; font-size: 13px; line-height: 21px; font-weight: 400; color: #687587; overflow-wrap: anywhere; }
                    .item_left .item_left_tops .item_tage { padding-top: 4px; font-size: 13px; line-height: 21px; color: #7b8492; overflow-wrap: anywhere; }
                    .item_left .item_left_boms { padding: 10px 0 0; }
                    .item_left .item_left_boms .btns1 { width: 100%; height: 44px; padding: 0 8px; font-size: 14px; line-height: 44px; border-radius: 4px; }
                }
            }
        }
        .News_hotspot .News_hotspot_box {
            .check_type {
                display: flex; flex-wrap: nowrap; justify-content: flex-start; gap: 0; padding-top: 12px;
                overflow-x: auto; overscroll-behavior-x: contain; border-bottom: 1px solid #e5eaf0;
                .tab_list { flex: 0 0 auto; min-height: 48px; padding: 12px 14px 0; margin: 0; }
                .tab_list .tab_title { font-size: 14px; line-height: 24px; white-space: nowrap; }
                .tab_list .borders { width: 100%; height: 3px; margin-top: 9px; }
                .tab_list:focus-visible { outline: 2px solid #377cfd; outline-offset: -2px; }
            }
            .check_item {
                display: flex; flex-direction: column; align-items: stretch; gap: 0; padding-top: 16px;
                .item_ac_left {
                    display: grid; grid-template-columns: minmax(0, 1fr) 88px; gap: 6px 12px;
                    width: 100%; height: auto; padding: 16px; background: #f2f6fc; border-radius: 4px;
                    .left_title { grid-column: 1; font-size: 17px; line-height: 26px; }
                    .left_texts { grid-column: 1; padding: 0; font-size: 13px; line-height: 22px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; }
                    .left_nums2 { grid-column: 1; font-size: 13px; line-height: 24px; color: #7b8492; }
                    .left_nums2 span { font-size: 18px; padding-right: 4px; }
                    .left_btns { grid-column: 2; grid-row: ~"1 / 4"; align-self: center; width: 88px; height: 44px; margin: 0; font-size: 14px; line-height: 44px; border-radius: 4px; }
                }
                .item_ac_right {
                    display: block; width: 100%; padding: 0;
                    .items {
                        display: grid; grid-template-columns: 88px minmax(0, 1fr); align-items: start; gap: 12px;
                        width: 100%; height: auto; min-height: 112px; padding: 16px 0; margin: 0;
                        border-bottom: 1px solid #edf0f5; border-radius: 0; background: #fff;
                        .item_img { width: 88px; height: 72px; border-radius: 4px; overflow: hidden; background: #f1f4f8; }
                        .item_img img { display: block; width: 100%; height: 100%; object-fit: cover; }
                        .item_info { min-width: 0; padding: 0; }
                        .item_info .item_title { font-size: 16px; line-height: 24px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; overflow-wrap: anywhere; }
                        .item_info .item_const { padding-top: 6px; font-size: 13px; line-height: 21px; color: #7b8492; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; overflow-wrap: anywhere; }
                        .item_info .item_const span { display: none; }
                        .item_info .item_icons { display: flex; flex-wrap: wrap; gap: 4px 10px; padding-top: 8px; }
                        .item_info .item_icons .icons { display: flex; align-items: center; gap: 4px; margin: 0; font-size: 13px; line-height: 20px; }
                        .item_info .item_icons .icons img { width: 13px; height: 13px; margin: 0; object-fit: contain; }
                    }
                }
            }
        }
        .Featured_Cases {
            border-top: 8px solid #f4f6f9;
            .Featured_Cases_box .list_box { display: block; padding-top: 8px; }
            .Featured_Cases_box .list_box .items {
                padding: 16px 0; margin: 0; border-radius: 0; border-bottom: 1px solid #edf0f5; background: #fff;
                .item_title { font-size: 16px; line-height: 26px; overflow-wrap: anywhere; }
                .item_const { margin-top: 6px; font-size: 14px; line-height: 24px; color: #687587; }
                .item_icons { justify-content: flex-start; gap: 16px; padding-top: 10px; margin-top: 10px; }
                .item_icons .icons { gap: 4px; margin: 0; font-size: 13px; line-height: 22px; }
            }
        }
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .Classroom.no-trans {
        .checks .check_box { grid-template-columns: repeat(4, minmax(0, 1fr)); }
        .Recommend_a_lawyer .Recommend_a_lawyer_box .list_item { grid-template-columns: repeat(3, minmax(0, 1fr)); }
    }
}
@media (max-width: 1024px) {
    .Classroom.no-trans .News_hotspot .News_hotspot_box .check_item .item_ac_right .items {
        grid-template-columns: minmax(0, 1fr) 96px;
        grid-template-rows: auto auto auto;
        gap: 6px 14px;
        min-height: 0;
        padding: 18px 0;
        border: 0;
        border-bottom: 1px solid #edf0f5;
        .item_img { grid-column: 2; grid-row: ~"1 / 3"; width: 96px; height: 76px; align-self: start; }
        .item_info { display: contents; }
        .item_info .item_title { grid-column: 1; grid-row: 1; font-size: 16px; line-height: 25px; font-weight: 600; color: #303846; }
        .item_info .item_const { grid-column: 1; grid-row: 2; padding: 0; font-size: 13px; line-height: 22px; -webkit-line-clamp: 1; color: #7b8492; }
        .item_info .item_icons { grid-column: ~"1 / -1"; grid-row: 3; justify-content: space-between; padding-top: 4px; color: #87909d; }
        .item_info .item_icons .icons { font-size: 13px; line-height: 22px; }
        &.news-without-image { grid-template-columns: minmax(0, 1fr); }
    }
}
@media (max-width: 1024px) {
    .Classroom.no-trans .Featured_Cases {
        background: #fff;
        .Featured_Cases_box .list_box { padding-top: 4px; }
        .Featured_Cases_box .list_box .items {
            position: relative;
            width: 100%; height: auto; min-height: 104px;
            padding: 18px 24px 18px 0; margin: 0;
            border: 0; border-bottom: 1px solid #edf0f5; border-radius: 0;
            .item_title {
                width: 100%; font-size: 16px; line-height: 26px; font-weight: 600; color: #303846;
                -webkit-line-clamp: 2; overflow-wrap: anywhere;
            }
            .item_const {
                margin-top: 8px; font-size: 14px; line-height: 24px; color: #748092;
                -webkit-line-clamp: 3; overflow-wrap: anywhere;
            }
            .item_const:empty { display: none; }
            .item_icons {
                border: 0; margin: 12px 0 0; padding: 0;
                justify-content: flex-start; gap: 20px;
                .icons { margin: 0; gap: 4px; font-size: 13px; line-height: 22px; color: #87909d; }
                .icons img { width: 14px; height: 14px; margin: 0; object-fit: contain; }
            }
            .case_arrow { position: absolute; right: 0; top: 22px; font-size: 16px; color: #8a98ab; }
            &:focus-visible { outline: 2px solid #377cfd; outline-offset: -2px; }
            &:active { background: #f7f9fc; }
            &:last-child { border-bottom: 0; }
        }
    }
}
</style>
